import { useIntlContext } from '@inbox-demo-nx/contexts';
import isThisYear from 'date-fns/isThisYear';
import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';
import { useCallback } from 'react';

function capitalizeFirstLetter(v: string) {
  return v.charAt(0).toUpperCase() + v.slice(1);
}

export function useFormatDateLine() {
  const {
    intlDateLineFormat,
    intlDateLineLastYearFormat,
    intlDateLineRelativeFormat,
  } = useIntlContext();
  return useCallback(
    (date: number) => {
      if (isToday(date)) {
        return capitalizeFirstLetter(
          intlDateLineRelativeFormat.format(0, 'day')
        );
      }
      if (isYesterday(date)) {
        return capitalizeFirstLetter(
          intlDateLineRelativeFormat.format(-1, 'day')
        );
      }
      return (
        isThisYear(date) ? intlDateLineFormat : intlDateLineLastYearFormat
      ).format(date);
    },
    [intlDateLineFormat, intlDateLineLastYearFormat, intlDateLineRelativeFormat]
  );
}
